import type {
  JabatanCompetencyLevel,
  JabatanLevelUpperCase,
} from 'types/competency-profile'

export const JabatanCompetencyLevels: JabatanCompetencyLevel = {
  Pertama: 2,
  Muda: 3,
  Madya: 4,
  Utama: 5,
}

export const DEPARTEMENT_LEVEL_MAPPING: Record<JabatanLevelUpperCase, number> =
  {
    PERTAMA: 2,
    MUDA: 3,
    MADYA: 4,
    UTAMA: 5,
  }

export const NON_PNS_LEVEL_MAPPING: Record<JabatanLevelUpperCase, string> = {
  PERTAMA: '0-7 tahun',
  MUDA: '8-14 tahun',
  MADYA: '15-21 tahun',
  UTAMA: 'Lebih dari 21 tahun',
}

export const SUB_COMPETENCY_LIST = [
  'pedagogik',
  'kepribadian',
  'sosial',
  'profesional',
]
